import { LngLat } from 'mapbox-gl';
import { computed } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useTenantInMarketStore } from '../..';
import useProperty from '../../hooks/useProperty';
import useTenantsInMarketWithFocusArea from '../../hooks/useTenantsInMarketWithFocusArea';
import { IDetailsTabProps } from "../../interfaces/IDetailsTabProps";
import useTenantsInMarketWithGlobalFilters from '../../interfaces/useTenantsInMarketWithGlobalFilters';
import GeometryService from '../../services/geometryService';
import TenantsInMarketGrid from '../tenantsInMarket/TenantsInMarketGrid';

function PropertyDetailsTenantsInMarketTab({ visible, setEntityCount }: IDetailsTabProps) {
    const { longitude, latitude } = useParams();
    const tenantInMarketStore = useTenantInMarketStore();
    const geometryService = useMemo(() => new GeometryService(), []);
    const coordinates = useMemo(() => new LngLat(Number(longitude), Number(latitude)), [longitude, latitude]);
    const property = useProperty(coordinates).property!;
    const tenantsInMarket = useTenantsInMarketWithFocusArea(useTenantsInMarketWithGlobalFilters(
        useMemo(() => computed(() => tenantInMarketStore.tenantsInMarket.filter(tim => geometryService.isPointInsideShape(property.centerPoint, tim.shape))), [property]).get()
    ));

    useEffect(() => setEntityCount(tenantsInMarket.length), [tenantsInMarket]);

    if (!visible)
        return null;

    return <TenantsInMarketGrid tenantsInMarket={tenantsInMarket} />;
}

export default observer(PropertyDetailsTenantsInMarketTab);